module.exports = __webpack_public_path__ + "img/color-dynamics-1_en.03e7f42.jpg";